<template>
  <div class="app-header">
    <div class="flex items-center justify-between">
      <div class="flex items-center">
        <app-header-account-sets class="ml-10px"/>
        <div class="h-input-group" v-if="currentAccountSets">
          <Input :value="currentAccountDate" disabled class="d-input"/>
          <span class="h-input-addon h-icon-calendar as-icon-calendar"></span>
        </div>
      </div>
      <div class="flex items-center">
        <i v-if="webConfig.qrCode" class="fi fi-kf w-20px h-20px text-hover" @click="showKf()"></i>
        <i class="fi fi-bz w-20px h-20px text-hover mx-20px" @click="showAbout()"></i>
        <!-- AI财务助手入口 -->
        <span class="ai-assistant-btn text-hover mr-16px" title="AI财务助手" @click="toggleAiPanel()">🤖</span>
        <div class="app-header-info mr-16px">
          <DropdownMenu className="app-header-dropdown" offset="0 5" :width="150" placement="bottom-end" :datas="infoMenu" @clickItem="trigger">
            <Avatar :src="avatarUrl" :width="30"><span>{{ User.realName }}</span></Avatar>
          </DropdownMenu>
        </div>
      </div>
    </div>
  </div>

  <!-- AI财务助手浮窗 -->
  <teleport to="body">
    <div v-if="aiPanelVisible" class="ai-assistant-panel" :class="{ 'ai-panel-fullscreen': aiFullscreen }" :style="{ clipPath: clipPath }" ref="aiPanel">
      <iframe
        :src="aiPanelUrl"
        class="ai-assistant-iframe"
        ref="aiIframe"
        frameborder="0"
        allow="microphone"
      ></iframe>
    </div>
  </teleport>
</template>
<script>
import {defineAsyncComponent, h} from 'vue';
import {mapGetters, mapState} from 'vuex';
import manba from 'manba';
import AppHeaderAccountSets from "./modules/app-header-account-sets";
import {layer} from "@layui/layer-vue";
import Renewal from "@/views/app/Renewal";
import setting from "@api/setting";
import About from "@/views/About.vue";
import KeFu from "@/views/KeFu.vue";
import {notice} from "heyui.ext";
import common from "@api/common";

export default {
  components: {
    AppHeaderAccountSets
  },
  data() {
    return {
      searchText: '',
      currentAccountDate: null,
      aiPanelVisible: false,
      aiFullscreen: false,
      clipPath: 'none',
      infoMenu: [
        {key: 'PersonalSetting', title: '账号信息', icon: 'h-icon-user'},
        {key: 'ChangePassword', title: '修改密码', icon: 'h-icon-lock'},
        {key: 'ChangePhoneNumber', title: '账号变更', icon: 'h-icon-link'},
        {key: 'MyOrders', title: '我的订单', icon: 'h-icon-list'},
        {key: 'logout', title: '退出登录', icon: 'h-icon-outbox'}
      ]
    };
  },
  computed: {
    ...mapState(['User', 'currentAccountSets', 'webConfig']),
    aiPanelUrl() {
      // 生产：https://ai.jibuyun.com/llm/（与 nginx aicaiwu-front.conf 一致）；可用 VUE_APP_AI_LLM_BASE 覆盖
      const base = process.env.VUE_APP_AI_LLM_BASE || '/llm/';
      const params = new URLSearchParams();
      if (this.currentAccountSets) {
        params.set('accountSetsId', this.currentAccountSets.id);
        params.set('companyName', this.currentAccountSets.companyName || '');
        params.set('accountStandard', this.currentAccountSets.accountStandard || '');
        params.set('vatType', this.currentAccountSets.vatType || '');
        if (this.currentAccountSets.encoding) {
          params.set('encoding', JSON.stringify(this.currentAccountSets.encoding));
        }
      }
      if (this.User && this.User.id) {
        params.set('userId', this.User.id);
        params.set('userName', this.User.realName || this.User.name || '');
      }
      // Sa-Token cookie 同域自动携带，这里额外透传 token 供跨域场景
      const token = document.cookie.split(';').map(c => c.trim())
        .find(c => c.startsWith('ai_fv3token='));
      if (token) {
        params.set('token', token.split('=')[1]);
      }
      return base + (params.toString() ? '?' + params.toString() : '');
    },
    ...mapGetters(['checkoutList']),
    sliderCollapsed: {
      get() {
        return this.$store.state.sliderCollapsed;
      },
      set(value) {
        this.$store.commit('updateSliderCollapse', value);
      }
    },
    accountDate() {
      return this.currentAccountSets ? manba(this.currentAccountSets.currentAccountDate).format("YYYY年MM月") : null;
    },
    avatarUrl() {
      return this.User.avatarUrl || '/images/yun.png'
    },
    dOp() {
      let filter = this.checkoutList.filter(val => val.status !== 2);
      return {
        start: filter[filter.length - 1].checkDate,
        end: filter[0].checkDate,
      }
    }
  },
  watch: {
    accountDate() {
      this.currentAccountDate = this.accountDate;
    }
  },
  mounted() {
    this.currentAccountDate = this.accountDate;
    window.addEventListener('message', this.handleIframeMessage);
    if (this.currentAccountSets && this.currentAccountSets.effectiveDate) {
      let day = manba(this.currentAccountSets.effectiveDate).distance(manba(), manba.DAY);
      if (day >= 0) {
        if (day < 15) {
          notice({
            type: 'warn',
            title: "续期提醒",
            content: `您当前账套将于 <b class="red-color">${day + 1}天</b> 后过期<br/>请及时联系客服续期～`,
            timeout: 0,
            buttons: [
              {
                name: '续期',
                style: 'primary',
                type: 'confirm'
              }
            ],
            events: {
              confirm: e => {
                this.doRenewal()
                e.close();
              }
            }
          });
        }
      } else {
        notice({
          type: 'error',
          title: "过期提醒",
          content: `您当前账套已过期，请联系客服续期～`,
          timeout: 0,
          buttons: [
            {
              name: '续期',
              style: 'primary',
              type: 'confirm'
            }
          ],
          events: {
            confirm: e => {
              this.doRenewal()
              e.close();
            }
          }
        });
      }
    }
  },
  beforeUnmount() {
    window.removeEventListener('message', this.handleIframeMessage);
  },
  methods: {
    handleIframeMessage(e) {
      if (!e.data || !e.data.type) return;
      if (e.data.type === 'ai-panel-close') {
        this.aiPanelVisible = false;
        this.aiFullscreen = false;
      } else if (e.data.type === 'ai-panel-fullscreen') {
        this.toggleFullscreen();
      } else if (e.data.type === 'ai-panel-resize') {
        if (this.$refs.aiPanel && e.data.width) {
          this.$refs.aiPanel.style.width = e.data.width + 'px';
        }
      } else if (e.data.type === 'ai-panel-rect') {
        this.updateClipPath(e.data.rect);
      }
    },
    updateClipPath(rect) {
      if (this.aiFullscreen) {
        this.clipPath = 'none';
        return;
      }
      // 给阴影留出一点空间 (20px)
      const p = 20;
      const l = Math.max(0, rect.left - p);
      const t = Math.max(0, rect.top - p);
      const r = rect.width + p * 2;
      const b = rect.height + p * 2;
      
      // 使用 polygon 定义可见区域，其他区域不可见且不可点击
      this.clipPath = `path('M ${l} ${t} h ${r} v ${b} h -${r} Z')`;
    },
    toggleAiPanel() {
      this.aiPanelVisible = !this.aiPanelVisible;
      if (!this.aiPanelVisible) {
        this.aiFullscreen = false;
        this.clipPath = 'none';
      }
    },
    toggleFullscreen() {
      this.aiFullscreen = !this.aiFullscreen;
      if (this.aiFullscreen) {
        this.clipPath = 'none';
      }
      // 通知内部全屏状态
      const iframe = this.$refs.aiIframe;
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage({ 
          type: 'resize', 
          isFullscreen: this.aiFullscreen
        }, '*');
      }
    },
    startResize(e) {
      e.preventDefault();
      const panel = this.$refs.aiPanel;
      const iframe = this.$refs.aiIframe;
      const startX = e.clientX;
      const startWidth = panel.offsetWidth;
      
      // 关键：在拖拽开始时，给 body 加一个透明遮罩，防止 iframe 抢夺鼠标事件
      const mask = document.createElement('div');
      mask.style.position = 'fixed';
      mask.style.top = '0';
      mask.style.left = '0';
      mask.style.width = '100vw';
      mask.style.height = '100vh';
      mask.style.zIndex = '100003';
      mask.style.cursor = 'ew-resize';
      document.body.appendChild(mask);

      const onMove = (ev) => {
        const newWidth = Math.max(320, startWidth + startX - ev.clientX);
        panel.style.width = newWidth + 'px';
        // 强制 iframe 内部 UI 联动（如果内部支持 postMessage）
        if (iframe && iframe.contentWindow) {
          iframe.contentWindow.postMessage({ type: 'resize', width: newWidth }, '*');
        }
      };
      const onUp = () => {
        document.body.removeChild(mask);
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onUp);
      };
      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', onUp);
    },
    trigger(data) {
      if (data === 'logout') {
        common.logout().then(() => {
          window.location.replace("/");
        });
      } else if (data === 'MyOrders') {
        // 跳转到我的订单页面
        this.$store.commit('newTab', {
          key: 'MyOrders',
          title: '我的订单'
        });
      } else {
        layer.open({
          title: "个人信息设置",
          shadeClose: false,
          zIndex: 999,
          area: ['500px', '450px'],
          content: h(defineAsyncComponent(() => import('@/views/personal/' + data + '.vue')))
        });
      }
    },
    showAbout() {
      layer.open({
        title: "关于" + this.webConfig.name,
        zIndex: 999,
        area: ['570px', 'auto'],
        content: h(About)
      });
    },
    showKf() {
      layer.open({
        title: "联系客服",
        zIndex: 999,
        area: ['400px', '300px'],
        content: h(KeFu)
      });
    },
    doRenewal() {
      const layerId = layer.open({
        title: "账套续期",
        shadeClose: false,
        closeBtn: false,
        zIndex: 1000,
        area: ['500px', 'auto'],
        content: h(Renewal, {
          onClose() {
            layer.close(layerId);
          },
          onSuccess() {
            layer.close(layerId);
          }
        })
      });
    },
    accountDateChange(val) {
      let date = manba(val.replace("年", "-").replace("月", "-") + "01").format();
      setting.accountSets.updateCurrentAccountDate(date).then(() => {
        this.$store.dispatch('init');
      })
    }
  }
};
</script>
<style lang="less">

.app-header {
  color: rgba(49, 58, 70, 0.8);

  .h-autocomplete {
    line-height: 1.5;
    float: left;
    margin-top: 15px;
    margin-right: 20px;
    width: 120px;

    &-show, &-show:hover, &-show.focusing {
      outline: none;
      box-shadow: none;
      border-color: transparent;
      border-radius: 0;
    }

    &-show.focusing {
      border-bottom: 1px solid #eee;
    }
  }

  &-info &-icon-item {
    cursor: pointer;
    display: inline-block;
    float: left;
    padding: 0 15px;
    height: @layout-header-height;
    line-height: @layout-header-height;
    margin-right: 10px;

    &:hover {
      background: @hover-background-color;
    }

    i {
      font-size: 18px;
    }

    a {
      color: inherit;
    }

    .h-badge {
      margin: 20px 0;
      display: block;
    }
  }

  .app-header-icon-item {
    margin-left: 20px;

    button {
      background-color: #ffffff;
    }
  }

  &-dropdown {
    float: right;
    padding: 0 5px 0 5px;

    .h-icon-down {
      right: 20px;
    }

    cursor: pointer;

    &:hover, &.h-pop-trigger {
      background: @hover-background-color;
    }

    &-dropdown {
      padding: 5px 0;

      .h-dropdownmenu-item {
        padding: 8px 20px;
      }
    }
  }

  &-menus {
    display: inline-block;
    vertical-align: top;

    > div {
      display: inline-block;
      font-size: 15px;
      padding: 0 25px;
      color: @dark-color;

      &:hover {
        color: @primary-color;
      }

      + div {
        margin-left: 5px;
      }

      &.h-tab-selected {
        color: @white-color;
        background-color: @primary-color;
      }
    }
  }
}

/* AI助手入口图标 */
.ai-assistant-btn {
  font-size: 20px;
  cursor: pointer;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  opacity: 0.8;
  transition: opacity 0.2s, transform 0.2s;
  user-select: none;
  &:hover {
    opacity: 1;
    transform: scale(1.15);
  }
}

/* AI助手浮窗 */
.ai-assistant-panel {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 99999;
  background: transparent;
  pointer-events: none; /* 关键：初始设为 none，通过 clip-path 局部生效 */

  &.ai-panel-fullscreen {
    background: #fff;
    pointer-events: auto;
    clip-path: none !important;
  }
}

.ai-assistant-iframe {
  width: 100% !important;
  height: 100% !important;
  border: none;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  background: transparent;
  pointer-events: auto; /* 关键：iframe 内部允许点击 */
}

@keyframes slideInRight {
  from { transform: translateX(100%); }
  to   { transform: translateX(0); }
}

/* 左侧拖拽调宽手柄 */
.ai-panel-resize-handle {
  position: absolute;
  top: 0;
  left: -5px; /* 往外偏移，覆盖住 iframe 自己的边缘 */
  width: 15px; /* 增加手柄宽度，确保盖住内部的拉伸条 */
  height: 100%;
  cursor: ew-resize;
  z-index: 100002;
  background: transparent;
  &:hover {
    background: rgba(78, 115, 223, 0.05);
    border-left: 3px solid #4e73df;
  }
}


.ai-assistant-iframe {
  width: 100% !important;
  height: 100% !important;
  border: none;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.as-icon-calendar {
  border: 1px solid #d3d3d3 !important;
  border-left: none !important;
  border-radius: 0 5px 5px 0 !important;
  height: 34px !important;

  &:before {
    vertical-align: middle;
  }
}

.d-input {
  height: 34px !important;
  width: 96px !important;
  padding-right: 0 !important;
  border-right: none !important;
  border-radius: 5px 0 0 5px !important;
}

.h-avatar-info {
  padding-left: 38px !important;
}
</style>
